export const LAUNCH_FILE_EXTENSIONS = [
  'pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'tif', 'tiff',
  'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
  'ai', 'eps', 'indd', 'idml', 'zip', 'csv', 'txt',
];

export const MAX_LAUNCH_FILE_BYTES = 100 * 1024 * 1024;
export const MAX_LAUNCH_FILES_PER_UPLOAD = 10;
export const LAUNCH_FILE_ACCEPT = LAUNCH_FILE_EXTENSIONS.map((extension) => `.${extension}`).join(',');
export const LAUNCH_FILE_TYPE_MESSAGE = 'Filtypen stöds inte. Tillåtna format är PDF, bilder, Office, Illustrator, InDesign, ZIP, CSV och text.';

export function launchFileError(
  file: Pick<File, 'name' | 'size'>,
  rules?: { allowedExtensions: string[]; maxFileMb: number },
): string | null {
  const extensions = rules?.allowedExtensions ?? LAUNCH_FILE_EXTENSIONS;
  const maxBytes = (rules?.maxFileMb ?? 100) * 1024 * 1024;
  const base = file.name.split(/[/\\]/).pop() || '';
  const dot = base.lastIndexOf('.');
  const extension = dot > 0 ? base.slice(dot + 1).toLowerCase() : '';
  if (!extensions.includes(extension)) return LAUNCH_FILE_TYPE_MESSAGE;
  if (file.size <= 0) return 'Filen är tom.';
  if (file.size > maxBytes) return `Filen är större än ${rules?.maxFileMb ?? 100} MB.`;
  return null;
}
